import { render, staticRenderFns } from "./depositFlowStart.vue?vue&type=template&id=e8efdd60&scoped=true"
import script from "./depositFlowStart.vue?vue&type=script&lang=js"
export * from "./depositFlowStart.vue?vue&type=script&lang=js"
import style0 from "./depositFlowStart.vue?vue&type=style&index=0&id=e8efdd60&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8efdd60",
  null
  
)

export default component.exports